import sectionTinoGridCss from '../css-snippets/section-tino-grid';

const html = `
<style>${sectionTinoGridCss}</style>
<div class="tino-grid-wrapper tino-grid-wrapper-unique-id" data-id="unique-id" data-attribute="product-grid-container" data-background="#EBE6E2" data-top-padding="true" data-bottom-padding="true">
   <div class="wrap-produc-grid container">
      <div class="header-grid">
         <h2 data-attribute="title-section" class="title-section">Anitho Blog</h2>
      </div>
      <div data-attribute="body-grid" data-item-bg="#f3f3f3" class="body-grid">
         <div class="swiper swiper-initialized swiper-horizontal swiper-backface-hidden">
            <div data-attribute="list-item" class="swiper-wrapper" id="swiper-wrapper-238a87f3ce1891a3" aria-live="polite">
               <div data-attribute="item-slide" class="swiper-slide swiper-slide-active" role="group" aria-label="1 / 3" style="width: 381.667px; margin-right: 8px;">
                  <a data-attribute="item-product" href="javascript:void(0)" class="item-product" style="background: #f3f3f3; color: #000000;">
                     <div class="wrap-img">
                        <img loading="lazy" data-attribute="product-image" class="product-image" src="https://cdn.skyfastimg.com/images/2025/09/03/image-68b7b203226e060d6be642ce.webp?w=700&amp;h=50&amp;q=80" alt="">
                     </div>
                     <div data-attribute="product-content" class="wrap-content">
                        <h3 data-attribute="title-item" class="title-item">
                           A Day in the Life of a Home Cook with Anitho
                        </h3>
                        <p data-attribute="description-item" class="description-item">
                           From breakfast to dinner, Anitho's tools are there to simplify every step of your cooking journey. Experience the difference with our innovative kitchen solutions.
                        </p>
                     </div>
                  </a>
               </div>
               <div data-attribute="item-slide" class="swiper-slide swiper-slide-next" role="group" aria-label="2 / 3" style="width: 381.667px; margin-right: 8px;">
                  <a data-attribute="item-product" href="javascript:void(0)" class="item-product" style="background: #f3f3f3; color: #000000;">
                     <div class="wrap-img">
                        <img loading="lazy" data-attribute="product-image" class="product-image" src="https://cdn.skyfastimg.com/images/2025/09/03/image-68b7b2267f625d5c50891062.webp?w=700&amp;h=50&amp;q=80" alt="">
                     </div>
                     <div data-attribute="product-content" class="wrap-content">
                        <h3 data-attribute="title-item" class="title-item">
                           The Science Behind Better Cooking: Anitho’s Sma...
                        </h3>
                        <p data-attribute="description-item" class="description-item">
                           Anitho’s products are designed with the science of cooking in mind. Explore our collection and elevate your culinary experience with tools that make every meal better.
                        </p>
                     </div>
                  </a>
               </div>
               <div data-attribute="item-slide" class="swiper-slide" role="group" aria-label="3 / 3" style="width: 381.667px; margin-right: 8px;">
                  <a data-attribute="item-product" href="javascript:void(0)" class="item-product" style="background: #f3f3f3; color: #000000;">
                     <div class="wrap-img">
                        <img loading="lazy" data-attribute="product-image" class="product-image" src="https://cdn.skyfastimg.com/images/2025/09/03/image-68b7b2932d30c20083febc80.webp?w=700&amp;h=50&amp;q=80" alt="">
                     </div>
                     <div data-attribute="product-content" class="wrap-content">
                        <h3 data-attribute="title-item" class="title-item">
                           How to Keep Your Meals Fresh and Delicious with...
                        </h3>
                        <p data-attribute="description-item" class="description-item">
                           With these tools from Anitho, keeping your meals fresh and delicious has never been easier. Visit our store to discover more innovative kitchen solutions!
                        </p>
                     </div>
                  </a>
               </div>
            </div>
            <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal swiper-pagination-lock"><span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1" aria-current="true"></span></div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
         </div>
      </div>
      <div data-attribute="row-btn" data-show-btn="true" class="row-btn" style="display: block;">
         <a data-background="#2d521d" data-color="#ffffff" data-radius="0" href="javascript:void(0)" data-attribute="btn-view-all" class="btn-view-all" style="background: #2d521d; color: #fff; border-radius: 0px">View all</a>
      </div>
   </div>
</div>
`;
export default html;
